import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  Button,
  Container,
} from 'reactstrap';

import { Link, NavLink } from 'react-router-dom'

export default class Navigation extends React.Component {
  
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,

      prevScrollpos: window.pageYOffset,
      visible: !this.props.white
    };
  }

  // Adds an event listener when the component is mount.
  componentDidMount() {
    if (!this.props.white) window.addEventListener("scroll", this.handleScroll);
  }

  // Remove the event listener when the component is unmount
  componentWillUnmount() {
    if (!this.props.white)
      window.removeEventListener("scroll", this.handleScroll);
  }

  // Hide or show the menu
  handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    
    if (currentScrollPos <= 75) {
      this.setState({ visible: true });
    } else if (currentScrollPos >= 75) {
      this.setState({ visible: false });
    }
  };
  
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    
    return (
      <Navbar
        dark
        expand="lg"
        fixed="top"
        className={'is-stuck ' + !this.state.visible }
      >
        <Container>
          <Link to="/" className="navbar-brand">
            <svg
              id="invoease"
              data-name="invoease"
              viewBox="0 0 554.48 75"
              width="160"
              className="mr-5 py-3"
            >
              <g id="Layer0_0_FILL" data-name="Layer0 0 FILL"><path className="cls-1" d="M53.72,4.19a40.86,40.86,0,0,0-11,7.93L41.59,2.47H26V73.26H43.4V37.15a22.43,22.43,0,0,1,2.29-9.94A19,19,0,0,1,52,20.05a17.32,17.32,0,0,1,9.46-2.77q8.31.13,12.61,5.44c2.86,3.54,4.3,8,4.3,13.38V73.16H95.94V36.1c-.09-7.46-1.43-13.66-4.11-18.82A27.67,27.67,0,0,0,81.23,5.62,28.42,28.42,0,0,0,66,1.51,28.53,28.53,0,0,0,53.72,4.19M17.51,2.28H.13v71H17.51v-71M347.18,5.05A31.75,31.75,0,0,0,334,17.47c-3.25,5.54-4.87,12.32-5,20.44.1,8.31,1.63,15.19,4.78,20.83A31.56,31.56,0,0,0,346.7,71.35a39.83,39.83,0,0,0,18.73,4.1,32.13,32.13,0,0,0,8.5-1.43,27.41,27.41,0,0,0,8.41-4.11A17.94,17.94,0,0,0,388.26,63l.95,10.32h16.44V2.66H388.83l-.57,9.74A22.59,22.59,0,0,0,379.18,4,30.41,30.41,0,0,0,365.81.94a40.83,40.83,0,0,0-18.63,4.11m2.29,21.3a18.24,18.24,0,0,1,7.46-7.26,22.33,22.33,0,0,1,10.5-2.48c5.54.09,9.94,1.62,13.19,4.49a19.31,19.31,0,0,1,6.49,10.51,24.18,24.18,0,0,1,0,12.8,19.38,19.38,0,0,1-6.49,10.51c-3.25,3-7.65,4.39-13.19,4.48a22.21,22.21,0,0,1-10.5-2.48,18.64,18.64,0,0,1-7.46-7.45A22.89,22.89,0,0,1,346.61,38a22.71,22.71,0,0,1,2.86-11.66m-83.39-21a32.61,32.61,0,0,0-13,13,40.27,40.27,0,0,0-4.68,19.1,39.65,39.65,0,0,0,4.68,19.78,31.56,31.56,0,0,0,13.28,13.18c5.82,3.06,12.8,4.68,20.92,4.68a53.23,53.23,0,0,0,11-1.14,41.67,41.67,0,0,0,10.61-3.83,32.36,32.36,0,0,0,8.78-6.49l-11.17-11a16.68,16.68,0,0,1-5.26,3.63,43.66,43.66,0,0,1-6.78,2.3,33.63,33.63,0,0,1-6.88.85c-6.21-.09-11.08-1.52-14.71-4.29a15.3,15.3,0,0,1-6.3-10.7h55c.86-9.75,0-17.77-2.67-24.27A29.34,29.34,0,0,0,306.3,5.62c-5.54-3.34-12.33-5-20.35-5a38.71,38.71,0,0,0-19.87,4.69m.67,24.36A18.49,18.49,0,0,1,274,19.38a22.24,22.24,0,0,1,12.51-3.44c5.06,0,9.17,1.15,12.42,3.44s5.16,5.73,5.83,10.32H266.56M204,1.23A38.24,38.24,0,0,0,184.5,6.29a34.13,34.13,0,0,0-12.61,13.18,39.27,39.27,0,0,0-4.3,18.63A39.3,39.3,0,0,0,172,56.73a33.43,33.43,0,0,0,12.61,13.18c5.45,3.25,11.94,5,19.59,5.07,7.64-.1,14.23-1.82,19.67-5.07a32.78,32.78,0,0,0,12.61-13.18A38.25,38.25,0,0,0,241,38.1a37.4,37.4,0,0,0-4.68-18.63A34.13,34.13,0,0,0,223.66,6.29a39.35,39.35,0,0,0-19.58-5.06M187.27,27.88a18.18,18.18,0,0,1,17-10.89,18.53,18.53,0,0,1,10.22,3.06,21.37,21.37,0,0,1,6.59,7.73,21.92,21.92,0,0,1,2.39,10.13A24.42,24.42,0,0,1,221.37,48a18.22,18.22,0,0,1-6.3,7.64,20.48,20.48,0,0,1-21.21,0,18.45,18.45,0,0,1-6.4-7.64,23.31,23.31,0,0,1-.19-20.16m-65.63-2.1L111.8,2.37H92.69L123,73.54h18.91L172,2.37H153l-9.74,23.7-10.7,29.61-10.89-29.9M498.69,5.43a32.57,32.57,0,0,0-12.9,13,38,38,0,0,0-4.58,19.11,40.69,40.69,0,0,0,4.58,19.77,31.69,31.69,0,0,0,13.28,13.19c5.73,3.05,12.71,4.68,20.83,4.68a53.23,53.23,0,0,0,11-1.15,41.27,41.27,0,0,0,10.61-3.82,32.24,32.24,0,0,0,8.79-6.5l-11.18-11a16.68,16.68,0,0,1-5.26,3.63,43.62,43.62,0,0,1-6.78,2.29,34.36,34.36,0,0,1-6.88.86q-9.31-.15-14.61-4.3a15.74,15.74,0,0,1-6.4-10.7h55.12c.86-9.74,0-17.77-2.68-24.26A29.25,29.25,0,0,0,539,5.72c-5.54-3.35-12.32-5-20.34-5a37.27,37.27,0,0,0-20,4.68m.76,24.27a18.28,18.28,0,0,1,7.36-10.32,22.27,22.27,0,0,1,12.51-3.44c5.07,0,9.27,1.15,12.42,3.44a14.78,14.78,0,0,1,5.83,10.32H499.45M440.8.85a34.19,34.19,0,0,0-7.07,1A32.56,32.56,0,0,0,424,5.62a21.24,21.24,0,0,0-7.17,6.78A18.69,18.69,0,0,0,414,22.72q.29,8,4.58,12.61A25.29,25.29,0,0,0,429.72,42a50.07,50.07,0,0,0,11.18,2.39,21.2,21.2,0,0,0,2.38.19c5,.19,8.6.86,10.7,2.1a5.65,5.65,0,0,1,3.35,5.35,6.42,6.42,0,0,1-1.91,4.58,10.42,10.42,0,0,1-4.69,2.87,17.26,17.26,0,0,1-6.2,1,16.25,16.25,0,0,1-3.73-.39,42,42,0,0,1-5-1A44.1,44.1,0,0,1,427,55.58a22.09,22.09,0,0,1-6.78-5.06L411.57,63a38.15,38.15,0,0,0,21.49,11.75,52.1,52.1,0,0,0,7.84.86h3.34c6.78,0,12.42-1,17-3.24a23.71,23.71,0,0,0,10.13-8.51,20.25,20.25,0,0,0,3.34-11.46c-.09-4.68-1-8.5-2.86-11.37a18.38,18.38,0,0,0-7.36-6.68A31.88,31.88,0,0,0,454.75,31a75.66,75.66,0,0,0-10.32-1.24c-1.34-.09-2.48-.29-3.63-.38a19.33,19.33,0,0,1-6.4-2,5.92,5.92,0,0,1-3.25-5.25,5.83,5.83,0,0,1,3.35-5.26,18.14,18.14,0,0,1,6.2-1.62c1-.09,2.11-.09,3.16-.09a26.92,26.92,0,0,1,9.55,1.43,21.88,21.88,0,0,1,8.12,4.87L471.27,10a36.91,36.91,0,0,0-12.7-7.45A48.87,48.87,0,0,0,443.76.65a29.62,29.62,0,0,0-3,.2Z" transform="translate(-0.13 -0.64)"/></g>
            </svg>
          </Link>

          <NavbarToggler onClick={this.toggle} className={'' + !this.state.isOpen } />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar>
              <li>
                <NavLink activeClassName="active" to="/" exact>Home</NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/pricing">Pricing</NavLink>
              </li>
              <li>
                <NavLink activeClassName="active" to="/features">Features</NavLink>
              </li>
            </Nav>
                      
            <Nav navbar className="ml-auto">
              <div className="d-none d-lg-block d-lg-flex">
                {/* <li>
                  <a href="tel:+17188199223" className="phone">+1 718 819 9223</a>
                </li> */}
                <li>
                  <a href="/sign-in"> LOGIN</a>
                </li>
                <li>
                  <a href="/sign-up" className="px-0 ml-lg-3 mx-auto"> <Button color="green">Start Free Trial</Button></a>
                </li>
              </div>

              <div className="d-flex d-lg-none">
                <div className="row w-100 mx-0">
                  <li className="col-sm-6">
                    <a href="/sign-in" className="px-0 ml-lg-3 mx-auto w-100"> <Button color="green" className="w-100">Login</Button></a>
                  </li>
                  <li className="col-sm-6">
                    <a href="/sign-up" className="px-0 ml-lg-3 mx-auto w-100"> <Button color="green" className="w-100">Start Free Trial</Button></a>
                  </li>
                </div>
              </div>

            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}